module.exports = __webpack_public_path__ + "img/ALSi6-Defib.095cb5ae.png";